import React, { DetailedHTMLProps, ReactNode } from 'react'
import { twMerge } from 'tailwind-merge'

export default function Label(
  props: DetailedHTMLProps<React.LabelHTMLAttributes<HTMLLabelElement>, HTMLLabelElement> & {
    inputElement: ReactNode
    inputWrapperClassName?: string
  },
) {
  return (
    <label
      className={twMerge(
        'mb-5 flex cursor-pointer gap-x-3 rounded-md border border-stone-300 px-2 py-4 text-stone-600',
        props.className,
      )}
    >
      <div className={twMerge('flex items-center', props.inputWrapperClassName)}>
        {props.inputElement}
      </div>
      {props.children}
    </label>
  )
}
